import { render, staticRenderFns } from "./walletAddressLog.vue?vue&type=template&id=71d5dfa9&scoped=true"
import script from "./walletAddressLog.vue?vue&type=script&lang=ts"
export * from "./walletAddressLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5dfa9",
  null
  
)

export default component.exports